import { cn } from '@/lib/cn';
import { inicialesDe } from '@/lib/negocio';

/**
 * El sello del negocio: sus iniciales en un cuadro de esquinas redondas, sobre el acento (el rojo de
 * Osito). Se lee con el nombre entero. 21-oct, macOS 27: 28 en la barra lateral, radio 7.
 */
export function Sello({ nombre, grande = false }: { nombre: string; grande?: boolean }) {
  return (
    <span
      role="img"
      aria-label={nombre}
      className={cn(
        'grid shrink-0 select-none place-items-center bg-acento-lleno font-bold tracking-tight text-white',
        grande ? 'h-14 w-14 rounded-2xl text-xl' : 'h-7 w-7 rounded-[7px] text-[13px]',
      )}
    >
      {inicialesDe(nombre)}
    </span>
  );
}
